'use client'

import { Fragment, useEffect } from 'react'
import { Divider, Spacer } from '@vinted/web-ui'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { ErrorState } from '@marketplace-web/shared/error-display'
import {
  getInfoBoardPosts,
  transformInfoBoardPostsResponse,
  InfoBoardPostModel,
} from '@marketplace-web/domain/info-board-data'

import { InfoPost } from './InfoPost'

const InfoBoard = () => {
  const {
    fetch: fetchInfoBoardPosts,
    transformedData: posts,
    error,
    isLoading,
  } = useFetch(getInfoBoardPosts, transformInfoBoardPostsResponse)

  useEffect(() => {
    fetchInfoBoardPosts()
  }, [fetchInfoBoardPosts])

  const renderPost = (post: InfoBoardPostModel, index: number) => {
    return (
      <Fragment key={index}>
        <div className="u-mobiles-only">
          <Spacer size={Spacer.Size.X3Large} />
        </div>
        <div className="u-desktops-only">
          <Spacer size={Spacer.Size.X4Large} />
        </div>
        <InfoPost {...post} />
        <div className="u-mobiles-only">
          <Spacer size={Spacer.Size.X3Large} />
        </div>
        <div className="u-desktops-only">
          <Spacer size={Spacer.Size.X4Large} />
        </div>
        <Divider />
      </Fragment>
    )
  }

  if (isLoading) return <ContentLoader testId="infoboard-loader" />

  if (error) return <ErrorState />

  return (
    <>
      <div className="u-mobiles-only">
        <Spacer size={Spacer.Size.Large} />
      </div>
      <div className="u-desktops-only">
        <Spacer size={Spacer.Size.X2Large} />
      </div>
      {posts?.map(renderPost)}
      <Spacer size={Spacer.Size.X6Large} />
    </>
  )
}

export default InfoBoard
